export class DialogModelImage {
    constructor(
      public imageUrl: any
    ) {}
  }